import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  // Auth Routes Start
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/LoginView.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/auth/ForgotPasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/views/auth/ResetPasswordView.vue"),
  },
  // Auth Routes End
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/modules/DashboardView.vue"),
    meta: { permission: "dashboard" },
  },
  {
    path: "/orders-scheduler",
    name: "orders-scheduler",
    component: () => import("@/views/modules/orders/OrderView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/shipping-order",
    name: "shipping-orders",
    component: () => import("@/views/modules/orders/shipping_orders/ShippingOrderView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/receiving-order",
    name: "receiving-orders",
    component: () => import("@/views/modules/orders/receiving_order/ReceivingOrderView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/edit-order",
    name: "edit-orders",
    component: () => import("@/views/modules/orders/edit_orders/EditOrderView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/orders-listing",
    name: "orders-listing",
    component: () => import("@/views/modules/orders/OrderListingView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/order-detail",
    name: "order-detail",
    component: () => import("@/views/modules/orders/OrderDetailView.vue"),
    meta: { permission: "orders" },
  },
  {
    path: "/user-profile",
    name: "user-profile",
    component: () => import("@/views/modules/users/UserProfile.vue"),
    meta: { permission: "profile" },
  },
  // Settings Routes
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/modules/setting/SettingView.vue"),
    meta: { permission: "settings" }
  },
  // Human Resource Route
  {
    path: "/human-resource",
    name: "human-resource",
    component: () => import("@/views/modules/human_resource/HumanResourceView.vue"),
    meta: { permission: null },
  },
  // Reports Route
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/views/modules/reports/WarehouseReceivingOrdersView.vue"),
    meta: { permission: null },
  },
  // Warehouse Routes Start
  {
    path: "/warehouse",
    name: "warehouse",
    component: () => import("@/views/modules/warehouse/WarehouseView.vue"),
    meta: { permission: "warehouse" },
  },
  // Warehouse Routes End
  // Customers Routes Start
  {
    path: "/customers",
    name: "customers",
    component: () => import("@/views/modules/customer/CustomerView.vue"),
    meta: { permission: "customers" },
  },
  // Customers Routes End
  // Suppliers Routes Start
  {
    path: "/suppliers",
    name: "suppliers",
    component: () => import("@/views/modules/supplier/SupplierView.vue"),
    meta: { permission: "suppliers" },
  },
  // Suppliers Routes End
  // Dispatch Routes Start
  {
    path: "/drivers",
    name: "drivers",
    component: () => import("@/views/modules/dispatch/driver/DriverView.vue"),
    meta: { permission: "drivers" },
  },
  {
    path: "/driver/:id",
    name: "driver",
    component: () => import("@/views/modules/dispatch/driver/DriverDetailView.vue"),
    meta: { permission: "drivers" },
  },
  {
    path: "/transporters",
    name: "transporters",
    component: () => import("@/views/modules/dispatch/transporter/TransporterView.vue"),
    meta: { permission: "transporters" },
  },
  {
    path: "/vehicles",
    name: "vehicles",
    component: () => import("@/views/modules/dispatch/vehicle/VehicleView.vue"),
    meta: { permission: "vehicles" },
  },
  {
    path: "/vehicle/:id",
    name: "vehicle",
    component: () => import("@/views/modules/dispatch/vehicle/VehicleDetailView.vue"),
    meta: { permission: "vehicles" },
  },
  {
    path: "/equipments",
    name: "equipments",
    component: () => import("@/views/modules/dispatch/equipment/EquipmentView.vue"),
    meta: { permission: "equipments" },
  },
  {
    path: "/equipment/:id",
    name: "equipment",
    component: () => import("@/views/modules/dispatch/equipment/EquipmentDetailView.vue"),
    meta: { permission: "equipments" },
  },
  // Dispatch Routes End
  // Inventory Route Start
  {
    path: "/inventory",
    name: "inventory",
    component: () => import("@/views/modules/inventory/InventoryView.vue"),
    meta: { permission: "inventory" },
  },
  // Inventory Route End
  // Errors Routes Start
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/errors/403Status.vue"),
  },
  {
    path: "/warehouse-reports",
    name: "warehouse-reports",
    component: () => import("@/views/modules/reports/WarehouseReceivingOrdersView.vue"),
    meta: { permission: "warehouse-reports" }
  },
  {
    path: "/supplier-reports",
    name: "supplier-reports",
    component: () => import("@/views/modules/reports/SupplierReceivingOrdersView.vue"),
    meta: { permission: "supplier-reports" }
  },
  {
    path: "/ship-order-reports",
    name: "ship-order-reports",
    component: () => import("@/components/page_components/modules/reports/ShipOrderReportsPage.vue"),
    meta: { permission: "shipping-order-reports" }
  },
  // Errors Routes End
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const nonAuthorizedRoutes = ["login", "forgot-password", "reset-password", "403"];

const authorizedUserRoutes = [
  "dashboard",
  "orders-scheduler",
  "shipping-orders",
  "receiving-orders",
  "edit-orders",
  "orders-listing",
  "order-detail",
  "user-profile",
  "warehouse",
  "customers",
  "suppliers",
  "drivers",
  "driver",
  "transporters",
  "vehicles",
  "vehicle",
  "equipments",
  "equipment",
  "inventory",
  "settings",
  "human-resource",
  "reports",
  "warehouse-reports",
  "supplier-reports",
  "ship-order-reports",
];

/**
 * Get user permissions from localStorage
 * @returns {Array} - Array of permission slugs
 */
const getUserPermissions = () => {
  try {
    const possibleKeys = ["roles_permissions", "role_permissions", "user_permissions"];
    let rawStorage = null;
    for (const key of possibleKeys) {
      rawStorage = localStorage.getItem(key);
      if (rawStorage) {
        break;
      }
    }
    if (!rawStorage) {
      return [];
    }
    const storage = JSON.parse(rawStorage);
    if (!storage.permissions) {
      return [];
    }
    return storage.permissions || [];
  } catch (error) {
    console.error("Failed to get user permissions:", error);
    return [];
  }
};

/**
 * Find the first permitted route for the user
 * @param {Array} userPermissions - Array of user permission slugs
 * @returns {Object} - Route object with name property
 */
const findNextPermittedRoute = (userPermissions) => {
  for (const routeName of authorizedUserRoutes) {
    const route = routes.find((r) => r.name === routeName);
    if (route && route.meta?.permission) {
      if (userPermissions.includes(route.meta.permission)) {
        return { name: routeName };
      }
    } else if (route && !route.meta?.permission) {
      // Routes like 403 that don't require permissions
      return { name: routeName };
    }
  }
  return { name: "login" };
};

// Router navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("access_token") || "";
  const userPermissions = getUserPermissions();
  const requiredPermission = to.meta?.permission;

  // If user is logged in and trying to access auth pages, redirect them
  if (token && nonAuthorizedRoutes.includes(to.name || "")) {
    // Check if user has dashboard permission, otherwise find next permitted route
    if (userPermissions.includes("dashboard")) {
      next({ name: "dashboard" });
    } else {
      next(findNextPermittedRoute(userPermissions));
    }
  } 
  // If trying to access non-auth routes without token
  else if (!token && !nonAuthorizedRoutes.includes(to.name || "")) {
    next({ name: "login" });
  }
  // If user has token but route is not in authorized routes
  else if (token && !authorizedUserRoutes.includes(to.name || "")) {
    next(findNextPermittedRoute(userPermissions));
  }
  // If user has token but no permissions and trying to access protected routes
  else if (token && !userPermissions.length && authorizedUserRoutes.includes(to.name || "") && to.name !== "403") {
    // Don't remove the token - redirect to 403 instead
    next({ name: "403" });
  }
  // Check specific permission for protected routes
  else if (token && requiredPermission && !userPermissions.includes(requiredPermission)) {
    next(findNextPermittedRoute(userPermissions));
  }
  // Allow access to non-auth routes when not logged in, or authorized routes when logged in
  else {
    next();
  }
});

export default router;
